import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IDatatableOutputDTO,
  IDatatableParams,
} from 'src/app/shared/datatables/datatables';
import { HttpParamsMapper } from 'src/app/shared/mappers/http-params.mapper';

export type AccountsUsersReportRow = {
  account: {
    id: number;
    name: string;
    email: string;
    mobile: string | null;
  };
  user: {
    id: number;
    name: string;
    email: string;
  };
  accountUser: {
    isActive: boolean;
    status: 'active' | 'pending' | 'inactive';
  };
};

export interface AccountsUsersReportFilter {
  userEmail?: string;
}

@Injectable({ providedIn: 'root' })
export class AdministrativeAccountsUsersReportV2Service {
  private readonly url = `${environment.api_v2}/v2/administrative/accounts-users`;

  constructor(private readonly http: HttpClient) {}

  search<Filter extends object = AccountsUsersReportFilter>({
    filter,
    page,
    perPage,
  }: IDatatableParams<Filter>): Observable<
    IDatatableOutputDTO<AccountsUsersReportRow>
  > {
    const params = HttpParamsMapper.toHttpParams({
      filter: JSON.stringify(filter ?? {}),
      page,
      perPage,
    });
    return this.http.get<IDatatableOutputDTO<AccountsUsersReportRow>>(this.url, {
      params,
    });
  }
}
